import { format } from 'date-fns';

export default format;
